import { render, staticRenderFns } from "./FileImagePreview.vue?vue&type=template&id=ee1c9d8e&scoped=true"
import script from "./FileImagePreview.vue?vue&type=script&lang=ts"
export * from "./FileImagePreview.vue?vue&type=script&lang=ts"
import style0 from "./FileImagePreview.vue?vue&type=style&index=0&id=ee1c9d8e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ee1c9d8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ee1c9d8e')) {
      api.createRecord('ee1c9d8e', component.options)
    } else {
      api.reload('ee1c9d8e', component.options)
    }
    module.hot.accept("./FileImagePreview.vue?vue&type=template&id=ee1c9d8e&scoped=true", function () {
      api.rerender('ee1c9d8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileImagePreview.vue"
export default component.exports